import React from 'react';

// SVG Inline
import SVG from 'react-inlinesvg';

import PixSrc from 'assets/images/icons/DesignSysten2.0/shopping_payment_finance/PIX.svg';
import BoletoSrc from 'assets/images/icons/DesignSysten2.0/shopping_payment_finance/Arquivo de Pedidos.svg';
import CoinSrc from 'assets/images/icons/DesignSysten2.0/shopping_payment_finance/Moeda.svg';
import PixFillSrc from 'assets/images/icons/DesignSysten2.0/shopping_payment_finance/PIX FILL.svg';
import CreditCardSrc from 'assets/images/icons/DesignSysten2.0/shopping_payment_finance/Cartão Crédito.svg';
import DebitCardSrc from 'assets/images/icons/DEBIT_CARD.svg';
import VoucherSrc from 'assets/images/icons/DesignSysten2.0/shopping_payment_finance/Voucher.svg';
import CashierSrc from 'assets/images/icons/DesignSysten2.0/shopping_payment_finance/Caixa.svg';
import MoneySrc from 'assets/images/icons/DesignSysten2.0/shopping_payment_finance/Dinheiro.svg';
import QrcodeSrc from 'assets/images/icons/DesignSysten2.0/shopping_payment_finance/QR Code.svg';
import ShoppingCartSrc from 'assets/images/icons/DesignSysten2.0/shopping_payment_finance/Carrinho de Compra.svg';

interface SVGInlineInterface {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const PixFill: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={PixFillSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const ShoppingCart: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={ShoppingCartSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Qrcode: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={QrcodeSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Cashier: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={CashierSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Boleto: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={BoletoSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Money: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={MoneySrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Voucher: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={VoucherSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const CreditCard: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={CreditCardSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const DebitCard: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={DebitCardSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Coin: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={CoinSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Pix: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={PixSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
